/* BentoBliss – Product image zoom / lightbox for the v2 product page.
   Click (or tap) a product image to open it full screen.
   Desktop: click the image to zoom in, move the mouse to pan, click again to zoom out.
   Mobile: tap to zoom in, drag to pan, tap again to zoom out, swipe to change image. */
(function () {
  'use strict';
  if (window.__bbZoom) return;
  window.__bbZoom = true;

  var css =
    '.bbp-slide img{cursor:zoom-in}' +
    '.bbz{position:fixed;inset:0;z-index:2147483000;background:rgba(252,248,240,.98);display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .2s;touch-action:none}' +
    '.bbz.is-open{opacity:1}' +
    '.bbz__stage{position:relative;width:100%;height:100%;overflow:hidden;display:flex;align-items:center;justify-content:center}' +
    '.bbz__img{max-width:92vw;max-height:88vh;object-fit:contain;transition:transform .25s ease;cursor:zoom-in;user-select:none;-webkit-user-drag:none}' +
    '.bbz.is-zoomed .bbz__img{cursor:zoom-out;transition:transform .25s ease, transform-origin 0s}' +
    '.bbz__btn{position:absolute;z-index:2;width:48px;height:48px;border-radius:50%;border:1px solid #e7e1d6;background:#fff;color:#1c1d1d;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 2px 10px rgba(0,0,0,.08);padding:0}' +
    '.bbz__btn:hover{background:#1c1d1d;color:#fff}' +
    '.bbz__close{top:18px;right:18px}' +
    '.bbz__prev{left:18px;top:50%;transform:translateY(-50%)}' +
    '.bbz__next{right:18px;top:50%;transform:translateY(-50%)}' +
    '.bbz__count{position:absolute;bottom:18px;left:50%;transform:translateX(-50%);background:#fff;border-radius:999px;padding:5px 12px;font-size:13px;font-weight:700;color:#1c1d1d;box-shadow:0 1px 4px rgba(0,0,0,.08)}' +
    /* magnifier button on the main image */
    '.bbz-mag{position:absolute;left:16px;bottom:16px;z-index:3;width:44px;height:44px;border-radius:50%;border:1px solid #e7e1d6;background:#fff;color:#1c1d1d;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,.08);padding:0}' +
    '.bbz-mag:hover{background:#1c1d1d;color:#fff}' +
    /* thumbnail strip arrows */
    '.bbz-thumbwrap{position:relative}' +
    '.bbz-tarrow{position:absolute;top:50%;transform:translateY(-50%);z-index:2;width:32px;height:32px;border-radius:50%;border:1px solid #e7e1d6;background:#fff;color:#1c1d1d;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 2px 6px rgba(0,0,0,.1);padding:0}' +
    '.bbz-tarrow:hover{background:#1c1d1d;color:#fff}' +
    '.bbz-tarrow[hidden]{display:none}' +
    '.bbz-tarrow--prev{left:0}.bbz-tarrow--next{right:0}.bbz-thumbwrap .bbp-thumbs{padding-left:38px;padding-right:38px}' +
    '@media (max-width:767px){' +
      '.bbz__img{max-width:100vw;max-height:78vh}.bbz__close{top:12px;right:12px}' +
      '.bbz__prev,.bbz__next{width:40px;height:40px;top:auto;bottom:16px;transform:none}.bbz__prev{left:16px}.bbz__next{right:16px}' +
      '.bbp .bbp-arrow{display:flex !important;width:36px;height:36px}.bbp .bbp-arrow--prev{left:22px}.bbp .bbp-arrow--next{right:22px}' +
      '.bbz-mag{left:auto;right:22px;bottom:12px;width:38px;height:38px}' +
      '.bbz-tarrow{width:28px;height:28px}.bbz-tarrow--prev{left:6px}.bbz-tarrow--next{right:6px}' +
    '}';

  function injectCss() {
    var s = document.createElement('style');
    s.textContent = css;
    document.head.appendChild(s);
  }

  function hiRes(src) {
    if (!src) return src;
    try {
      var u = new URL(src, location.href);
      u.searchParams.set('width', '2400');
      return u.toString();
    } catch (e) {
      return src;
    }
  }

  var icon = {
    close: '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    prev: '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M20 12H4m0 0 6-6m-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    next: '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M4 12h16m0 0-6-6m6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    mag: '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="m15.5 15.5 5 5M10.5 7.5v6M7.5 10.5h6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    chevL: '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="m15 5-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    chevR: '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="m9 5 7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  var box, img, countEl, images = [], index = 0, zoomed = false, lastFocus = null;
  var SCALE = 2.5;

  function build() {
    box = document.createElement('div');
    box.className = 'bbz';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Product image zoom');
    box.innerHTML =
      '<div class="bbz__stage"><img class="bbz__img" alt=""></div>' +
      '<button type="button" class="bbz__btn bbz__close" aria-label="Close">' + icon.close + '</button>' +
      '<button type="button" class="bbz__btn bbz__prev" aria-label="Previous image">' + icon.prev + '</button>' +
      '<button type="button" class="bbz__btn bbz__next" aria-label="Next image">' + icon.next + '</button>' +
      '<span class="bbz__count"></span>';
    img = box.querySelector('.bbz__img');
    countEl = box.querySelector('.bbz__count');
    box.querySelector('.bbz__close').addEventListener('click', close);
    box.querySelector('.bbz__prev').addEventListener('click', function () { show(index - 1); });
    box.querySelector('.bbz__next').addEventListener('click', function () { show(index + 1); });
    box.querySelector('.bbz__stage').addEventListener('click', function (e) {
      if (e.target !== img && !zoomed) close();
    });

    /* Desktop: click to zoom, mouse move to pan */
    img.addEventListener('click', function (e) {
      if (touchMoved) return;
      setZoom(!zoomed, e.clientX, e.clientY);
    });
    img.addEventListener('mousemove', function (e) {
      if (zoomed) setOrigin(e.clientX, e.clientY);
    });

    /* Mobile: drag to pan when zoomed, swipe to change when not */
    var startX = 0, startY = 0, touchMoved = false;
    box.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      touchMoved = false;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    box.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 1) return;
      var t = e.touches[0];
      if (Math.abs(t.clientX - startX) > 8 || Math.abs(t.clientY - startY) > 8) touchMoved = true;
      if (zoomed) setOrigin(t.clientX, t.clientY);
    }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (!touchMoved) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (!zoomed && Math.abs(dx) > 50) show(index + (dx < 0 ? 1 : -1));
      setTimeout(function () { touchMoved = false; }, 50);
    });

    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(index - 1);
      if (e.key === 'ArrowRight') show(index + 1);
    });
    document.body.appendChild(box);
  }

  function setOrigin(x, y) {
    var r = img.getBoundingClientRect();
    var px = Math.min(100, Math.max(0, ((x - r.left) / r.width) * 100));
    var py = Math.min(100, Math.max(0, ((y - r.top) / r.height) * 100));
    img.style.transformOrigin = px + '% ' + py + '%';
  }

  function setZoom(on, x, y) {
    zoomed = on;
    box.classList.toggle('is-zoomed', on);
    if (on && x != null) setOrigin(x, y);
    img.style.transform = on ? 'scale(' + SCALE + ')' : '';
  }

  function show(i) {
    if (!images.length) return;
    index = (i + images.length) % images.length;
    setZoom(false);
    img.src = images[index].src;
    img.alt = images[index].alt || '';
    countEl.textContent = (index + 1) + ' / ' + images.length;
    var multi = images.length > 1;
    box.querySelector('.bbz__prev').style.display = multi ? '' : 'none';
    box.querySelector('.bbz__next').style.display = multi ? '' : 'none';
    countEl.style.display = multi ? '' : 'none';
  }

  function open(list, start) {
    if (!box) build();
    images = list;
    lastFocus = document.activeElement;
    show(start);
    box.style.display = 'flex';
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { box.classList.add('is-open'); });
    box.querySelector('.bbz__close').focus();
  }

  function close() {
    if (!box) return;
    box.classList.remove('is-open');
    setZoom(false);
    document.documentElement.style.overflow = '';
    setTimeout(function () { box.style.display = 'none'; }, 200);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function collect(gallery) {
    return Array.prototype.slice.call(gallery.querySelectorAll('.bbp-slide img')).map(function (el) {
      return { src: hiRes(el.currentSrc || el.src), alt: el.alt, el: el };
    });
  }

  function currentIndex(gallery) {
    var track = gallery.querySelector('[data-track]');
    if (!track) return 0;
    return Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
  }

  function enhance(gallery) {
    if (gallery.__bbz) return;
    gallery.__bbz = true;
    var stage = gallery.querySelector('.bbp-gallery__stage');
    if (stage && gallery.querySelector('.bbp-slide img')) {
      var mag = document.createElement('button');
      mag.type = 'button';
      mag.className = 'bbz-mag';
      mag.setAttribute('aria-label', 'Zoom image');
      mag.innerHTML = icon.mag;
      mag.addEventListener('click', function (e) {
        e.preventDefault();
        var list = collect(gallery);
        if (!list.length) return;
        var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-slide]'));
        var cur = slides[currentIndex(gallery)];
        var curImg = cur && cur.querySelector('img');
        var start = curImg ? list.findIndex(function (x) { return x.el === curImg; }) : 0;
        open(list, Math.max(0, start));
      });
      stage.appendChild(mag);
    }
    var thumbs = gallery.querySelector('[data-thumbs]');
    if (thumbs) {
      var wrap = document.createElement('div');
      wrap.className = 'bbz-thumbwrap';
      thumbs.parentNode.insertBefore(wrap, thumbs);
      wrap.appendChild(thumbs);
      var tp = document.createElement('button');
      var tn = document.createElement('button');
      tp.type = tn.type = 'button';
      tp.className = 'bbz-tarrow bbz-tarrow--prev';
      tn.className = 'bbz-tarrow bbz-tarrow--next';
      tp.setAttribute('aria-label', 'Previous image');
      tn.setAttribute('aria-label', 'Next image');
      tp.innerHTML = icon.chevL;
      tn.innerHTML = icon.chevR;
      wrap.appendChild(tp);
      wrap.appendChild(tn);
      var prevMain = gallery.querySelector('[data-prev]');
      var nextMain = gallery.querySelector('[data-next]');
      tp.addEventListener('click', function () { if (prevMain) prevMain.click(); else thumbs.scrollBy({ left: -200, behavior: 'smooth' }); });
      tn.addEventListener('click', function () { if (nextMain) nextMain.click(); else thumbs.scrollBy({ left: 200, behavior: 'smooth' }); });
      var sync = function () {
        var hasMore = thumbs.querySelectorAll('[data-thumb]').length > 1;
        tp.hidden = tn.hidden = !hasMore;
      };
      sync();
      window.addEventListener('resize', sync);
    }
  }

  function init() {
    injectCss();
    Array.prototype.forEach.call(document.querySelectorAll('.bbp [data-gallery]'), enhance);
    document.addEventListener('click', function (e) {
      var target = e.target.closest && e.target.closest('.bbp-slide img');
      if (!target) return;
      var gallery = target.closest('[data-gallery]');
      if (!gallery) return;
      var list = collect(gallery);
      var start = list.findIndex(function (x) { return x.el === target; });
      e.preventDefault();
      open(list, Math.max(0, start));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
